import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { User } from '@core/account-types';
import { AdminsAvatarsComponent } from '@core/account-ui';
import { trackByValue } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  AvatarComponent,
  BadgeComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';
import type { Visibility } from '@core/visibility-types';
import { VisibilityLevel } from '@core/visibility-types';

@Component({
  selector: 'rt-visibility-avatars-list',
  styleUrls: ['./visibility-avatars-list.component.less'],
  templateUrl: './visibility-avatars-list.component.html',
  imports: [
    AdminsAvatarsComponent,
    AvatarComponent,
    TruncateComponent,
    TranslatePipe,
    RtTooltip,
    BadgeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisibilityAvatarsListComponent {
  public readonly VisibilityLevel = VisibilityLevel;
  public readonly avatarsLimit = 3;
  public readonly avatarsMoreCountLimit = 99;
  public readonly tooltipListLimit = 30;

  @Input({ required: true }) public visibility: Visibility;
  @Input({ required: true }) public users: Record<number, User | null>;
  @Input({ required: true }) public moreTitle: string;

  public trackBy = trackByValue;

  public usersToShow: User[];
  public usersToShowInTooltip: User[];
  public avatarMoreCounter: string;
  public tooltipMoreCounter: number;

  public ngOnChanges() {
    this.usersToShow = this.getUsersToShow(this.users, this.visibility);
    this.usersToShowInTooltip = this.usersToShow.slice(0, 10);

    this.avatarMoreCounter =
      this.usersToShow.length - this.avatarsLimit > this.avatarsMoreCountLimit
        ? `+99`
        : `${this.usersToShow.length - this.avatarsLimit}`;

    this.tooltipMoreCounter = Math.abs(this.usersToShowInTooltip.length - this.tooltipListLimit);
  }

  private getUsersToShow(users: Record<number, User | null>, visibility: Visibility): User[] {
    if (visibility.level === VisibilityLevel.Public) {
      return Object.values(<User[]>users);
    }

    return <User[]>visibility.adminIds.map(id => users[id]).filter(v => v !== null);
  }
}
